import { useCallback, useEffect, useMemo, useState } from "react";

import {
	ReservationDetailLocalCancelFeeTransferRejectInputZodSchema,
	type ReservationDetailLocalCancelFeeTransferRejectInputType,
} from "./validation-schema";

import type { SafeParseError } from "zod";

export const useHandleFormState = () => {
	/**
	 * 非承認理由
	 */
	const [rejectReason, setRejectReason] = useState<string>("");
	/**
	 * 返金理由を更新
	 */
	const handleChangeRejectReason = useCallback((value: string) => {
		setRejectReason(value);
	}, []);
	/**
	 * 不足金額
	 */
	const [insufficientAmount, setInsufficientAmount] = useState<number | undefined>(1);
	/**
	 * 不足金額を更新
	 */
	const handleChangeInsufficientAmount = useCallback((value: number | undefined) => {
		setInsufficientAmount(value);
	}, []);

	const [validationErrors, setValidationErrors] = useState<
		SafeParseError<ReservationDetailLocalCancelFeeTransferRejectInputType> | undefined
	>(undefined);
	/**
	 * state の変更を監視し、バリデーションを実行
	 */
	useEffect(() => {
		const zodErrors = ReservationDetailLocalCancelFeeTransferRejectInputZodSchema.safeParse({
			rejectReason,
			insufficientAmount,
		});

		zodErrors.success ? setValidationErrors(undefined) : setValidationErrors(zodErrors);
	}, [insufficientAmount, rejectReason]);

	const rejectReasonErrorMessage = useMemo(
		() => validationErrors?.error.formErrors.fieldErrors.rejectReason?.at(0),
		[validationErrors?.error.formErrors.fieldErrors.rejectReason],
	);
	const insufficientAmountErrorMessage = useMemo(
		() => validationErrors?.error.formErrors.fieldErrors.insufficientAmount?.at(0),
		[validationErrors?.error.formErrors.fieldErrors.insufficientAmount],
	);
	const hasError = useMemo(() => validationErrors !== undefined, [validationErrors]);

	return {
		rejectReason,
		rejectReasonErrorMessage,
		insufficientAmount,
		insufficientAmountErrorMessage,
		hasError,
		//
		handleChangeRejectReason,
		handleChangeInsufficientAmount,
	};
};
